import { Paper } from '@mui/material';
import * as React from 'react';

export default function Panel(props)
{
  return <Paper
    sx={{
      p: 2,
      display: 'flex',
      flexDirection: 'column',
    }}
  >{props.children}</Paper>
}